// extracted by mini-css-extract-plugin
module.exports = {"truncated":"MainContainer_truncated__jrGga","root":"MainContainer_root__XPSB_"};